import { computed, type Ref } from 'vue'
import { useDisplay } from 'vuetify'
import { useStore } from 'vuex'

import { PROJECT_NAV_DRAWER_WIDTHS } from '@/common/layout/constants'

type UseNavigationDrawerReturn = {
  drawerWidths: Ref<{
    mini: number,
    unfolded: number,
    current: number,
    currentPx: string,
  }>
}

const MINI_WIDTH = PROJECT_NAV_DRAWER_WIDTHS.RAW.FOLDED

export function useNavigationDrawer (): UseNavigationDrawerReturn {
  const { mobile, width, xs } = useDisplay()
  const store = useStore();

  const unfoldedWidth = computed(() => {
    switch (true) {
      case xs.value: return Math.trunc(width.value * .8)
      case mobile.value: return Math.trunc(width.value * .33)
      default: return PROJECT_NAV_DRAWER_WIDTHS.RAW.REGULAR
    }
  })

  const current = computed(() => {
    if (mobile.value) {
      return 0
    }

    return store.state.global.mini
      ? MINI_WIDTH
      : unfoldedWidth.value
  })

  const drawerWidths = computed(() => ({
    mini: MINI_WIDTH,
    unfolded: unfoldedWidth.value,
    current: current.value,
    currentPx: `${current.value}px`,
  }))

  return { drawerWidths }
}
